
import Checkbox from '@mui/material/Checkbox'

import { useMatomo } from '@jonkoops/matomo-tracker-react'


import React, { Fragment as F, useContext, useEffect, useState } from 'react'
import Modal from 'react-modal'
import {
  useNavigate,
} from 'react-router'
import {
  Link,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from '$shared'
import {
  AppCtx,
} from '$src/App'
import {
  BanksCtx,
} from '$src/components/banks'
import {
  defaultSavedQuery,
  FiltersBox,
  ImportListModal,
  QueriesCtx,
} from '$src/components/queries'
import {
  ReportsCtx,
} from '$src/components/reports'

/*
 * DeleteModal
 *
 * Currently used only in AdvancedReportEditModal
**/
const DeleteModal = (props) => {
  // logg(props, 'DeleteModal')

  const apiRouter = useApiRouter()
  const navigate  = useNavigate()

  /* ctx */

  const {
    deleteModalOpen, setDeleteModalOpen,
    loading, setLoading,
    selectedResource, setSelectedResource,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in DeleteModal')

  const {
    refreshQueriesList,
    setSelectedQueries,
  } = useContext(QueriesCtx)

  const {
    refreshAdvancedReportsList,
    refreshReportsList,
  } = useContext(ReportsCtx)

  /* methods */

  /* _TODO: rename to afterDelete()
  **/
  const handleDelete = () => {
    setLoading(true)
    fetch(apiRouter.resourcePath(selectedResource), { method: 'DELETE' }).then(r => r.json()).then(inns => {
      toast('Deleted')
    }).catch((err) => {
      logg(err, 'could not delete resource')
      toast(`Could not delete this resource`)
    }).finally(async () => {
      switch (selectedResource.kind) {
        case C.kinds.AdvancedReport:
        case C.kinds.AdvancedReport_financials:
        case C.kinds.AdvancedReport_fintegration:
          await refreshAdvancedReportsList()
          break

        case C.kinds.Report:
          await refreshReportsList()
          break

        case C.kinds.Query:
        case C.kinds.List:
          navigate('/')
          await refreshQueriesList()
          break

        default:
          logg(selectedResource, 'selectedResource')
          throw '3w6 - this should not happen'
      }
      setSelectedResource({})
      setSelectedQueries({}) // this isn't injected as props.afterDelete, which is poor architecture, but ain't no harm in clearing this every time.
      setLoading(false)
      setDeleteModalOpen(false)
      navigate('/')
    })
  }

  return <Modal
    ariaHideApp={false}
    className="DeleteModal TinyModal BaseModal"
    isOpen={deleteModalOpen}
    onRequestClose={ () => setDeleteModalOpen(false) }
    overlayClassName="DeleteModalOverlay"
  >
    <div className='header'>
      <h5 >Confirm Delete</h5>
      <div className='close' onClick={() => setDeleteModalOpen(false)}>&times;</div>
    </div>
    <div className='modal-body'>
      <br /><br /><br />
      <button className='Btn' onClick={handleDelete}>Delete</button>
    </div>
  </Modal>

}
export default DeleteModal